import React, { useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import $ from "jquery";

var bgimg2 = require("./../../images/our-team5/logo.jpg");
var bgimg1 = require("./../../images/background/bg-image.png");
var videoURL = require("./../../images/aboutpage.MP4");
const About3 = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Add event listener for modal close
    $("#myModal2").on("hidden.bs.modal", () => {
      if (videoRef.current) {
        videoRef.current.pause();
      }
    });

    // Cleanup event listener on component unmount
    return () => {
      $("#myModal2").off("hidden.bs.modal");
    };
  }, []);

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };
  return (
    <>
      <div
        className={`section-full mobile-page-padding p-t80 p-b50`}
        style={{
          backgroundImage: "url(" + bgimg1 + ")",
          objectPosition: "bottom",
        }}
      >
        <div className="container">
          <div className="section-content">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="about-home-3 m-b30">
                  <h2 className="m-t0 m-b20 sx-tilte">SUNLIGHT CREATIONZ</h2>
                  <p>
                    Born out of creativity in 2022, Sunlight Creationz Inc. was
                    founded to reimagine luxury wedding decor. When affordable
                    elegance felt out of reach, we set out to craft stunning,
                    innovative designs that transform spaces and bring dream
                    weddings to life.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="video-section-full-v2">
                  <div
                    className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                    style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                  >
                    {/* <div className="overlay-main bg-black opacity-04" /> */}
                    {/* <div className="video-section-inner">
                      <div className="video-section-content">
                        <NavLink
                          to={"#"}
                          className="play-now"
                          data-toggle="modal"
                          data-target="#myModal2"
                          onClick={handlePlayClick}
                        >
                          <i className="icon fa fa-play" />
                          <span className="ripple" />
                        </NavLink>
                        <div className="video-section-bottom">
                          <h3 className="sx-title text-white">
                            
                            <br />
                          
                          </h3>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="myModal2" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            {/* <ReactPlayer url={videoURL} /> */}
            <video ref={videoRef} controls className="video-player">
              <source src={videoURL} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </>
  );
};

export default About3;
